import { render, staticRenderFns } from "./RaceAlertConfiguration.vue?vue&type=template&id=4889e295&"
import script from "./RaceAlertConfiguration.vue?vue&type=script&lang=js&"
export * from "./RaceAlertConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports